// extracted by mini-css-extract-plugin
export default {"rodo-page":"RodoPage_rodo-page__APiIP"};